// Base configuration for all environments
const config = {
  development: {
    API_BASE_URL: 'http://localhost:3232'
  },
  production: {
    API_BASE_URL: 'https://weekly.globe-groupe.com' // Empty string for relative paths in production
  },
  test: {
    API_BASE_URL: 'http://localhost:3232'
  }
};

// Get current environment, fallback to 'development' if not set
const env = process.env.NODE_ENV || 'development';

// Export the configuration for the current environment. The env override serves the
// Docker bench, where the API rides the same nginx origin (http://weekly.globe.docker).
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || config[env].API_BASE_URL;

// Connect's public URL, as seen by the BROWSER: the login redirect target, the SSO
// logout endpoint, and the admin console this app links to.
// Default when absent: https://connect.globe-groupe.com
export const CONNECT_UI_URL = process.env.REACT_APP_CONNECT_UI_URL || 'https://connect.globe-groupe.com';

// The OAuth client id, needed browser-side only to end the shared SSO session on
// logout. An identifier, not a secret — hardcoded on purpose (same as Gallery).
export const CONNECT_CLIENT_ID = 'weekly';

// Kept only to purge the legacy `authToken` cookie this app used to set family-wide.
export const COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN || '.globe-groupe.com';

// You can add more configuration exports here if needed
export default {
  API_BASE_URL
};
